import dayjs from 'dayjs';
import { getFormattedDuration, TranslationHistoryItem } from '../../helpers';
import style from './HistoryListItem.module.css';

interface HistoryListItemProps {
  item: TranslationHistoryItem;
  dataLength: number;
  index: number;
  onClick?: (item: TranslationHistoryItem) => void;
}

export const HistoryListItem = ({
  item,
  dataLength,
  index,
  onClick,
}: HistoryListItemProps) => {
  return (
    <div
      className={`${style.historyItem} ${style.clickable} ${
        index === dataLength - 1 ? style.lastHistoryItem : ''
      }`}
      onClick={() => onClick?.(item)}
    >
      <p>{index + 1}</p>
      <div className={style.useraName}>
        <p>{item.translator?.userName}</p>
        <p className={style.userNameLabel}>Перекладач</p>
      </div>
      <div className={style.useraName}>
        <p>{item.client?.userName || item.external?.userName || '—'}</p>
        <p className={style.userNameLabel}>
          {item.client?.userName
            ? 'Клієнт'
            : item.external?.userName
              ? 'Гість'
              : 'Клієнт'}
        </p>
        {/* Компанія, гостьовим доступом якої скористались (для гостя) або компанія клієнта. */}
        {item.companyName && (
          <p className={style.companyLabel}>{item.companyName}</p>
        )}
      </div>
      <div>
        <p>{dayjs(item.createdAt).format('HH:mm')}</p>
      </div>
      <div>
        <p>{dayjs(item.createdAt).format('DD.MM.YYYY')}</p>
      </div>
      <div>
        <p>{getFormattedDuration(item.callDuration)}</p>
      </div>
      <div>
        <p>{item.finishedBy}</p>
      </div>
    </div>
  );
};
